/**
 * copied from [_responsive.module.scss](../../ui/styles/mixins/_responsive.module.scss)
 */
export const breakpointMB = 768;
/**
 * copied from [_responsive.module.scss](../../ui/styles/mixins/_responsive.module.scss)
 */
export const breakpointTB = 979;
/**
 * copied from [_responsive.module.scss](../../ui/styles/mixins/_responsive.module.scss)
 */
export const breakpointSD = 1440;
/**
 * copied from [_responsive.module.scss](../../ui/styles/mixins/_responsive.module.scss)
 */
export const breakpointLD = 1920;
